export const BannerApiEndpoint = {
  fetchBannerList: '/banners',
  registBanner: '/banners',
  updateBanner: '/banners/:bannerId',
  deleteBanner: '/banners/:bannerId',
  fetchBanner: '/banners/:bannerId',
};
